var scope_0 = require('C:/Users/maste/source/repos/JacobAshcraftStatic/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0636a73ffe324560957b8a841e8aa521.js').default;
var scope_1 = require('C:/Users/maste/source/repos/JacobAshcraftStatic/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_2 = require('C:/Users/maste/source/repos/JacobAshcraftStatic/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/73cf6394492e251506410de6933c0616.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    